import * as React from 'react';
import { useEffect } from 'react';
import { Redirect } from 'react-router';
import { Analytics } from 'modules/common/util/Analytics';

/** Redirects and logs the redirect to analytics under `id`. */
export const TrackedRedirect: React.FC<{ id: string; to: string }> = ({ id, to }) => {
  useEffect(() => {
    Analytics.track(Analytics.FunctionalArea.GENERAL, 'Redirected', { redirectId: id });
  }, [id]);

  return <Redirect to={to} />;
};
